// The old 10-lead demo cap has been removed. Every account starts on
// the Pro tier (with a 7-day free trial) which is unlimited, so we no
// longer surface a lead-count badge in the header.
export const LeadCountBadge = () => null;
